import { createSlice } from "@reduxjs/toolkit";
import { getEventFeedbackMetrics } from "../../actions/feedbackActions";
import { EventFeedbackMetrics } from "../../../types/feedbackmetrics";

const initialState: {
    loading: boolean;
    error: string | null;
    success: boolean;
    data: EventFeedbackMetrics | null;
  } = {
    loading: false,
    error: null,
    success: false,
    data: null,
  };

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEventFeedbackMetrics.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(getEventFeedbackMetrics.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload.result;
    });
    builder.addCase(getEventFeedbackMetrics.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
});

export default feedbackSlice.reducer;
